module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: _vm.cclass,
    style: (_vm.wStyle),
    attrs: {
      "id": "map-div"
    }
  }, [_c('div', {
    staticClass: "center-block full",
    class: _vm.mcClass,
    style: (_vm.mcStyle),
    attrs: {
      "id": "map_canvas"
    }
  })]), _vm._v(" "), _c('audio', {
    ref: "alarm",
    attrs: {
      "muted": ""
    }
  }, [_c('source', {
    attrs: {
      "src": "static/audio/alarm.mp3",
      "type": "audio/mp3"
    }
  }), _vm._v(" "), _c('source', {
    attrs: {
      "src": "static/audio/alarm.wav",
      "type": "audio/wav"
    }
  }), _vm._v(" Your browser does not support the audio element.\n  ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0b79e1cc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Map.vue
// module id = 1681
// module chunks = 6